import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import iconHome from '../../assets/images/icons/Cinzentos/Home.svg';
import { config } from '../../common/';
import * as ValueAndCare from '../../valueandcare';

const BaseLayout: React.FC<{}> = () => {
    const { t } = useTranslation();
    const [tab, setTab] = useState(1);

    const changeTab = (tabIdx: number) => {
        if (tab !== tabIdx) {
            setTab(tabIdx);
        }
    };

    return (
        <div className={classNames(['grid-container', 'padding-bottom-4', 'value-service'])}>
            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <h1 className={'header'}>{t('cards:baseHeader')}</h1>
                </div>
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <h2>{t('cards:footer.topText2')}</h2>
                </div>
                <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                    <ul className={'tabs'} data-active-collapse="true" id="collapsing-tabs">
                        <li className={classNames(['tabs-title', { 'is-active': tab === 1 }])}>
                            <a onClick={() => changeTab(1)} className={classNames([{ 'text-bold': tab === 1 }])}>
                                {t('cards:cardsHeader')}
                            </a>
                        </li>
                        <li className={classNames(['tabs-title', { 'is-active': tab === 2 }])}>
                            <a onClick={() => changeTab(2)} className={classNames([{ 'text-bold': tab === 2 }])}>
                                {t('cards:packagedHeader')}
                            </a>
                        </li>
                        <li className={classNames(['tabs-title', 'float-right'])}>
                            <a className={'header-btn'} href={config.BaseURL}>
                                <img src={iconHome} alt={t(`common:home`)} />
                                {t(`common:home`)}
                            </a>
                        </li>
                    </ul>
                    {tab === 1 && <ValueAndCare.CardsLayout />}
                    {tab === 2 && <ValueAndCare.PacksLayout />}
                </div>
            </div>
        </div>
    );
};

export default BaseLayout;
